import {
    MouseEvent, useEffect, useRef, useState,
} from 'react';

const useImagesCarousel = (scrollIndicatorAnimation: boolean) => {
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const [isAnimationActive, setIsAnimationActive] = useState<boolean>(scrollIndicatorAnimation);

    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const imageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scrollContainerNode = scrollContainerRef?.current;

        const stopAnimation = (): void => {
            setIsAnimationActive(false);
        };

        if (scrollIndicatorAnimation && scrollContainerNode) {
            scrollContainerNode.addEventListener('animationend', stopAnimation);
        }

        return () => {
            if (scrollContainerNode) {
                scrollContainerNode.removeEventListener('animationend', stopAnimation);
            }
        };
    }, [scrollIndicatorAnimation]);

    const handleBulletClick = (e: MouseEvent<HTMLButtonElement>, targetSlide: number): void => {
        e.preventDefault();
        e.stopPropagation();

        const slideWidth = imageRef?.current?.offsetWidth;

        if (slideWidth) {
            scrollContainerRef?.current?.scrollTo({
                top: 0,
                left: targetSlide * slideWidth,
                behavior: 'smooth',
            });
        }
    };

    const handleSliderMove = (): void => {
        const currentScrollPosition = scrollContainerRef?.current?.scrollLeft || 0;
        const slideWidth = imageRef?.current?.offsetWidth || 0;

        const slideIndex = Math.round(currentScrollPosition / slideWidth);

        if (slideIndex !== currentSlide) {
            setCurrentSlide(slideIndex);
        }
    };

    return {
        isAnimationActive,
        currentSlide,
        scrollContainerRef,
        imageRef,
        handleBulletClick,
        handleSliderMove,
    };
};

export default useImagesCarousel;
